var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcoFacebook = function SvgIcoFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.278,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "ico-facebook",
    d: "M2.595 20.5h4.027V10.415h2.81l.3-3.377H6.623V5.115c0-.8.16-1.111.93-1.111h2.18v-3.5H6.944c-3 0-4.348 1.32-4.348 3.846v2.692H.501v3.419h2.095Z",
    fill: "#35272a",
    stroke: "rgba(0,0,0,0)"
  })));
};

export default SvgIcoFacebook;